import moment from "moment";
import { storeSoap } from "@/store/modules/soap";
import { storePenunjang } from "@/store/modules/penunjang";
import { storeResepFarmasi } from "@/store/modules/resepfarmasi";
import { storeSuket } from "@/store/modules/suket";
import AsuhanKebidananGadarStore from "@/store/modules/AsuhanKebidananGadarStore";
import AsuhanKeperawatanGadarStore from "@/store/modules/AsuhanKeperawatanGadarStore";
import AsesmenAwalGadar from "@/store/modules/AsesmenAwalGadar";
import { storeResume } from "@/store/modules/resume";
import storeBilling from "@/store/modules/Billing";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import ResumeRanapStore from "@/store/modules/ResumeRanapStore";
import storeAsesmenKemoterapi from "@/store/modules/AsesmenKemoterapi";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import StoreSuketPulang from "@/store/modules/SuketPulang";
import StoreSuketGadar from "@/store/modules/SuketGawatDarurat";
import StoreSuketKematian from "@/store/modules/SuketKematian";
import SuketDirawat from "@/store/modules/SuketDirawat";
import LaporanOperasi from "@/store/modules/LaporanOperasi";
import { MuatDetailKunjunganParam } from "@/types/riwayat";

function formatTanggal(tanggal: string | null | undefined): string {
  return tanggal ? moment(tanggal, "DD-MM-YYYY").format("YYYY-MM-DD") : "";
}

export function bersihkanDetailKunjungan(): void {
  storeSoap.clear_soap_all();
  storePenunjang.clear_list_ro();
  storePenunjang.clear_list_lab();
  storePenunjang.clear_hasil_ro();
  storePenunjang.clear_penunjang_lain();
  storeResepFarmasi.clear_list_resepfarmasi();
  storeResepFarmasi.clear_detail_resepfarmasi();
  storeSuket.clear_riwayatSK();
  AsuhanKebidananGadarStore.clearListAskeb();
  AsuhanKeperawatanGadarStore.clearListAskep();
  AsesmenAwalGadar.clearData();
  storeResume.clearResume();
  storeBilling.clearBilling();
  AsesmenAwalRanapMedisStore.reset();
  ResumeRanapStore.reset();
  storeAsesmenKemoterapi.reset();
  storeAssesmenRalan.reset();
  TandaVitalStore.reset();
  CatatanPemberianObatStore.reset();
  RegisterKunjungan.reset();
}

export function muatDetailKunjungan(param: MuatDetailKunjunganParam): void {
  const register = param.register;

  storePenunjang.act_list_ro_byReg(register);

  storeResepFarmasi.act_list_resepFarmasi_byReg(register);
  storeSuket.actRiwatarSK_on_reg(register);
  AsuhanKebidananGadarStore.getListAskeb(register);
  AsuhanKeperawatanGadarStore.getListAskep(register);

  AsesmenAwalGadar.getByRegister(register);
  AsesmenAwalRanapMedisStore.getByRegister(register);
  ResumeRanapStore.getByRegister(register);

  StoreSuketPulang.getSuketByRegister(register);
  StoreSuketGadar.getSuketByRegister(register);
  StoreSuketKematian.getSuketByRegister(register);
  SuketDirawat.getSuketByRegister(register);
  storeAssesmenRalan.actAsesmenAwal({ unit_id: param.unitId, reg: register });
  storeAsesmenKemoterapi.getAsesmenKemoterapiByReg(register);
  storeResume.act_resume_on_reg({ reg: register, idUser: "" });
  storeBilling.getDiagnosis(register);
  storeBilling.getProcedure(register);

  const keluar =
    param.keluar == null
      ? new Date().toISOString().substr(0, 10)
      : formatTanggal(param.keluar);

  storePenunjang.act_list_lab_byRm({
    rm: param.rm,
    masuk: formatTanggal(param.masuk),
    keluar: keluar
  });
  storePenunjang.act_penunjang_lain_byReg(register);

  TandaVitalStore.getByRegister(register);
  LaporanOperasi.getByRegister(register);
  CatatanPemberianObatStore.getByRegister(register);
  RegisterKunjungan.getRegister(register);
}
